<template>
    <div>
		<button type="button" class="text-primary hover:bg-primary hover:text-white border border-primary  px-4 py-2 mx-0 outline-none focus:shadow-outline" @click="showModal = true">USE A TOKEN TO ATTEND THIS EVENT</button>
		<!--Overlay-->
		<div class="overflow-auto" style="background-color: rgba(0,0,0,0.5)" v-show="showModal" :class="{ 'fixed inset-0 z-10 flex items-center justify-center': showModal }">
			<!--Dialog-->
			<div class="w-11/12 md:max-w-md mx-auto rounded shadow-lg py-4 text-left px-6" v-show="showModal" x-transition:enter="ease-out duration-300" x-transition:enter-start="opacity-0 scale-90" x-transition:enter-end="opacity-100 scale-100" x-transition:leave="ease-in duration-300" x-transition:leave-start="opacity-100 scale-100" x-transition:leave-end="opacity-0 scale-90">

				<!--Title-->
				<div class="flex justify-between items-center pb-3">
					<p class="text-2xl font-bold">Use a token to attend this event?</p>
					<div class="cursor-pointer z-50" @click="showModal = false">
						<svg class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
							<path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
						</svg>
					</div>
				</div>

				<!-- content -->
				<p v-text="'You have '+ this.tokenCount + ' tokens remaining. Are you sure you wish to use one of them to attend this event?'"></p>
				<div class="flex justify-end pt-2">
					<button :class="'px-10 bg-transparent p-3 border border-primary text-primary hover:bg-primary hover:text-white mr-2' + (disabledButton == true ? 'opacity-50' : '') " @click="redeemToken($event)">Redeem</button>
					<button class="px-10 bg-transparent p-3 border border-primary  text-primary hover:bg-primary hover:text-white mr-2" @click="showModal = false">Cancel</button>
				</div>
				<!--Footer-->

			</div>
			<!--/Dialog -->
		</div><!-- /Overlay -->
	
    </div>

</template>

<script>
const axios = require('axios');
export default {
    name:'eventtokenredemption',
    props:['laravelUrl', 'tokenCount', 'userId', 'eventId'],
    data: function() {
		return {
			showModal: false,
			disabledButton: false,
		}
	},
    methods: {
        redeemToken(e) {
			if (!this.disabledButton) {
				this.disabledButton = true
				e.preventDefault()
				var root = this
				axios.post(this.laravelUrl + '/api/token/redeem', {
					event: root.eventId,
					user: root.userId
				})
				.then(function (response) {
					// handle success
					root.showModal = false
					root.disabledButton = false
					location.reload();
				});
			}
        }
    }
}
</script>